import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../constants/common'
import { HTML_LINK_TARGET } from '../../../constants/html'
import { useInitData } from '../../../hooks'
import { loadAppVersion } from '../../../utils/appVersion'
import { Link } from '../../Link'

import * as styles from './PageFooter.module.css'

function PageFooter() {
  const {
    uk: { name, office },
  } = useInitData()

  const { t } = useTranslation()

  const [version, setVersion] = useState(EMPTY_STRING)

  const addressCompany = office?.address?.value

  useEffect(() => {
    loadAppVersion().then(setVersion)
  }, [])

  return (
    <footer className={styles.PageFooter}>
      <p>
        <span>{`© ${t('Footer.AllRightsReserved')}. ${name} | `}</span>
        <Link
          rel='noopener noreferrer'
          target={HTML_LINK_TARGET.blank}
          to='https://www.idwell.com/de/impressum'
          variant='underline'
        >
          {t('Footer.Impressum')}
        </Link>
        <span>{` | ${t('Footer.IdwellVersion')} ${version}`}</span>
        {addressCompany ? (
          <>
            <br />
            <span>{addressCompany}</span>
          </>
        ) : null}
      </p>
    </footer>
  )
}

export default PageFooter
